/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUser } from '../models/work-user';

@Injectable({ providedIn: 'root' })
export class WorkUsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersV1ControllerFindAllPaginated()` */
  static readonly UsersV1ControllerFindAllPaginatedPath = '/v1/users';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV1ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 250
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersService.UsersV1ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkUser>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV1ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 250
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.usersV1ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `usersV1ControllerFindAll()` */
  static readonly UsersV1ControllerFindAllPath = '/v1/users/withPermissions';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUser>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersService.UsersV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUser>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUser>> {
    return this.usersV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUser>>): Array<WorkUser> => r.body)
    );
  }

  /** Path part for operation `usersV1ControllerFindNextBirthdays()` */
  static readonly UsersV1ControllerFindNextBirthdaysPath = '/v1/users/nextBirthdays';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV1ControllerFindNextBirthdays()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindNextBirthdays$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersService.UsersV1ControllerFindNextBirthdaysPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV1ControllerFindNextBirthdays$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindNextBirthdays(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.usersV1ControllerFindNextBirthdays$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `usersV1ControllerFindOne()` */
  static readonly UsersV1ControllerFindOnePath = '/v1/users/{id}';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV1ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindOne$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUser>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersService.UsersV1ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUser>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV1ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV1ControllerFindOne(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<WorkUser> {
    return this.usersV1ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUser>): WorkUser => r.body)
    );
  }

}
